import React, { useEffect} from "react";
import {useToaster} from "react-hot-toast";

import styles from "./Toast.module.css";
import NormalToast from "./NormalToast";
import {localStorageData} from "../../utils/helpers";


export default function ToastCollection() {
    const {toasts, handlers} = useToaster();
    const key = "toastArr";

    const setStorageValue = (value) => {
        if (value != null) {
            localStorageData[key] = value;
            if (window.navigator.cookieEnabled) {
                localStorage.setItem(key, JSON.stringify(value));
            }
        }
    };

    useEffect(() => {
        let copy = JSON.parse(JSON.stringify(toasts));
        setStorageValue(copy);
    }, [toasts]);

    return (
        <div className={styles.mask}>
            {toasts.map((toastObj) => {
                return (<NormalToast key={toastObj.id} toastObj={toastObj} handlers={handlers}/>);
            })}
        </div>
    );

}








